const initialState = {
  pageIsOffCanvas: false,
  pageCanvasDirection: null,
  isModalOpen: false,
  openModalType: null,
  openModalData: null,
  modalMessages: null,
  toggledPanelIds: []
}

/**
 * UI state store action handler
 * @param  {Object} action Object
 * @param  {Object} state  Object
 * @return {Object} new State
 */
export default (state = initialState, action) => {
  switch (action.type) {
    case 'toggleOffCanvas':
      const direction = action.payload
      return {
        ...state,
        'pageIsOffCanvas': !state['pageIsOffCanvas'],
        'pageCanvasDirection': direction
      }

    case 'closeModal':
      return {
        ...state,
        isModalOpen: false,
        openModalType: null,
        openModalData: null,
        modalMessages: null
      }

    case 'openModal':
      const { type, payload } = action.payload
      return {
        ...state,
        isModalOpen: true,
        openModalType: type,
        openModalData: payload
      }

    case 'showModalMessage':
      return {
        ...state,
        modalMessages: action.payload
      }

    case 'dismissModalMessage':
      return {
        ...state,
        modalMessages: null
      }

    case 'togglePanel':
      const { toggledPanelIds } = state
      const panelId = action.payload
      const panelToggled = toggledPanelIds.indexOf(panelId) >= 0

      let ids = panelToggled ? toggledPanelIds.filter((id) => { return id !== panelId }) : [...toggledPanelIds, panelId]

      return { ...state, toggledPanelIds: ids }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/layout.js